import script from "./OverviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewPanel.vue?vue&type=script&setup=true&lang=js"

import "./OverviewPanel.vue?vue&type=style&index=0&id=447b8f30&lang=css"

const __exports__ = script;

export default __exports__